import { Modal } from '../../../modal/Modal';

import TickIcon from '@crazyegginc/hatch/dist/images/icon-tick-circle-filled.svg?react';

export function CloseWindowModal() {
  return (
    <Modal dialogClassName="!top-[150px] !translate-y-0" dismissable={false} disableOutsideClick={true}>
      <div className="w-9 h-7 flex items-center justify-center relative">
        <div className="w-8 h-8 bg-white rounded-full" />
        <TickIcon className="w-9 h-9 fill-current text-green-500 absolute" />
      </div>
      <div className="text-white text-2xl font-bold mt-4">You’re all set!</div>
      <div className="mt-2.5 mb-5 text-gray-200">Your page has opened in a new tab. You can close this window now.</div>
    </Modal>
  );
}
